// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'caret-2-left';

export const Component = () => (
  <path d='M11.902 12.537c-.143-.24-.239-.432-.239-.67 0-.24.096-.48.288-.67l6.8-8.861.144-.144a1.27 1.27 0 0 1 .575-.144c.67 0 1.006.336 1.006.958 0 .144-.048.335-.192.575l-6.034 8.285 5.987 8.19c.143.335.239.527.239.67 0 .623-.335.958-1.006.958-.191 0-.383-.047-.575-.143l-.143-.144-6.849-8.86Zm-7.663-.049c-.144-.239-.239-.431-.239-.67 0-.24.096-.479.287-.67l6.801-8.86.144-.144A1.27 1.27 0 0 1 11.807 2c.67 0 1.005.335 1.005.958 0 .144-.047.335-.19.575l-6.035 8.285 5.986 8.19c.144.335.24.526.24.67 0 .623-.336.958-1.006.958-.191 0-.383-.048-.575-.144l-.144-.144-6.848-8.86Z' />
);

export const viewBox = '0 0 25 25';
